import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/AIInHRComparisonSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeapAboutSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeapAI2026Section.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeapAutonomousSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeapDemo.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeapFAQs.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeapFooter.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeapPageHeroSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeappageNavbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeapSoftLaunch.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeapStatsSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeapStepsSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeapStickFooter.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/LeapVisionSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/ScrollReveal.jsx");
